import { useLingui } from '../../../../../../node_modules/@lingui/react/dist/index.mjs';
import { getTranslatedError } from '../../../utils/getTranslatedError.mjs';

const JIT_PROVISIONING_ERRORS = [
    'email_jit_provisioning_not_allowed',
    'invalid_email_for_jit_provisioning'
];
/**
 * Translates error message to user friendlier format including handling for JIT errors
 */ const useParseErrorMessage = ()=>{
    const { i18n: $__i18n, _: $__ } = useLingui();
    return (error, { email, org: organizationName })=>{
        if (JIT_PROVISIONING_ERRORS.includes(error.error_type)) {
            return $__i18n._({
                id: "error.jitIneligible",
                values: {
                    email: email,
                    organizationName: organizationName
                }
            });
        }
        return getTranslatedError(error, $__);
    };
};

export { useParseErrorMessage };
//# sourceMappingURL=useParseErrorMessage.mjs.map
